import apiClient from '../../../api/apiClient';
import { ADMIN_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = ADMIN_REST_API_BASE_URL;

export const getInvitationsBySubscription = (subid) =>
  apiClient.get(`${REST_API_BASE_URL}/invitations/${subid}`);
//export const getAllAppsByAccount = (id) => apiClient.get(`${REST_API_BASE_URL}/message/${id}/apps`);

// export const saveInvitation = (invitation) => apiClient.post(REST_API_BASE_URL + '/invitation', invitation);
// export const saveInvitation = (membershipid, subscriptionid, invitation, groupName) => apiClient.post(`${REST_API_BASE_URL}/dashboard/membership/${membershipid}/subscription/${subscriptionid}/invitation?groupName=${groupName}`, invitation);
// export const saveInvitation = (membershipid, subscriptionid, invitation, groupName) => apiClient.post(`${REST_API_BASE_URL}/dashboard/subscription/${subscriptionid}/invitation?groupName=${groupName}`, invitation);
export const saveInvitation = (invitation, groupName) =>
  apiClient.post(
    `${REST_API_BASE_URL}/dashboard/invitation?groupName=${groupName}`,
    invitation,
  );

export const getInvitation = (membershipid, subscriptionid, id) =>
  apiClient.get(
    `${REST_API_BASE_URL}/dashboard/membership/${membershipid}/subscription/${subscriptionid}/invitation/${id}`,
  );

export const updateInvitation = (id, invitation) =>
  apiClient.put(`${REST_API_BASE_URL}/invitation/${id}`, invitation);

export const deleteInvitation = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/invitation/${id}`);

export default apiClient;
